import { Cart, ProductBuilderMachineContext } from '../../../../types';

type AddToCartDev = (
  context: ProductBuilderMachineContext,
) => Promise<Partial<Cart>>;

export const getCartDev: AddToCartDev = context => {
  return new Promise(resolve => {
    return setTimeout(() => {
      return resolve({ items: [] });
      // return resolve({ items: [{ product_type: 'Measure Insurance' }] });
    }, 1500);
  });
};
